var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"pa-3"},_vm._l((_vm.imageAll),function(item,idx){return _c('v-col',{key:idx,staticClass:"d-flex child-flex"},[_c('v-img',{attrs:{"max-width":"100%","src":_vm.baseUrl + '/' + item.location}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }